module.exports = __webpack_public_path__ + "img/craft.ca35a0b.jpg";